<script>
	import Map from './Map.svelte';
	import Tools from "./lib/Tools.svelte";
</script>

<main>
	<Map lat={40} lon={0} zoom={2}>
		<Tools/>
	</Map>

</main>
	
<style>
	main {
		text-align: center;
		width: 100%;
		height: 100%;
		max-width: 100%;
	}
	
	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style>

